import { Expose } from 'class-transformer';

export class LeadershipDashboardDto {
  @Expose()
  convertedMonthDoDateRevenue: number;

  @Expose()
  scheduledMonthToDateRevenue: number;
}
